import {createContext, useContext, useReducer} from "react";

const INITIAL_CONCURSO = {
    edital: '', logo: '', nome: '',
}


const reducer = (state, action) => {
    switch (action.type) {
        case "LOGIN":
            sessionStorage.setItem('candidatoState',JSON.stringify({...state, isLogged: true,token:action.payload}));
            return {...state, isLogged: true,token:action.payload};
        case "LOGOUT":
            return {...state, isLogged: false};
        case "NOVO_CONCURSO":
            return {...state, concurso: action.payload}
        case "CONCURSO_NAO_ENCONTRADO":
            return {...state, concurso: {edital:'Concurso não encontrado',logo: 'https://www.ibfc.org.br/assets_site/img/logo.png'}}
        case "REFRESH":
            return JSON.parse(sessionStorage.getItem('candidatoState'));
        default:
            return state

    }
}


const useCandidatoReducer = () => {
    const [candidatoState, candidatoDispatch] = useReducer(reducer, {
        isLogged: false, concurso: INITIAL_CONCURSO
    })

    return {candidatoState, candidatoDispatch}
}

export default useCandidatoReducer;
